import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { useFetchHCaptchaToken } from "@faire/retailer-visitor-shared/hooks/hCaptcha/useFetchHCaptchaToken";
import { hCaptchaQueryKey } from "@faire/retailer-visitor-shared/lib/captchaUtils";
import { getSettingEnableHCaptchaIntegration } from "@faire/retailer-visitor-shared/settings/getSettingEnableHCaptchaIntegration";
import { useHCaptchaStore } from "@faire/retailer-visitor-shared/stores/domain/HCaptchaStore";
import login from "@faire/web-api--source/api/v2/users/login/post";
import { useQueryClient } from "@tanstack/react-query";
/**
 * Wrapper for fetchHCaptchaToken that also calls login endpoint with
 * the fetched hCaptcha token.
 *
 * @returns hCaptchaLogin(request: ILoginRequest): Promise<ILoginResponse>
 */ export var useHCaptchaLogin = function() {
    var fetchHCaptchaToken = useFetchHCaptchaToken(getSettingEnableHCaptchaIntegration()).fetchHCaptchaToken;
    var queryClient = useQueryClient();
    var _useHCaptchaStore = _sliced_to_array(useHCaptchaStore([
        "widgetID"
    ]), 1), widgetID = _useHCaptchaStore[0].widgetID;
    var queryKey = hCaptchaQueryKey(widgetID);
    var hCaptchaLogin = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(request) {
            var loginResponse, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchHCaptchaToken(true)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            6
                        ]);
                        return [
                            4,
                            login(_object_spread({}, request))
                        ];
                    case 3:
                        loginResponse = _state.sent();
                        return [
                            2,
                            loginResponse
                        ];
                    case 4:
                        error = _state.sent();
                        // invalidate hCaptcha token if login fails
                        return [
                            4,
                            queryClient.invalidateQueries({
                                queryKey: queryKey
                            })
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2,
                            Promise.reject(error)
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function hCaptchaLogin(request) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        hCaptchaLogin: hCaptchaLogin
    };
};
